module.exports = __webpack_public_path__ + "img/my-data-icon.af62c336.svg";